import { render, staticRenderFns } from "./allActiveSch.vue?vue&type=template&id=437e825a&scoped=true&"
import script from "./allActiveSch.vue?vue&type=script&lang=js&"
export * from "./allActiveSch.vue?vue&type=script&lang=js&"
import style0 from "./allActiveSch.vue?vue&type=style&index=0&id=437e825a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437e825a",
  null
  
)

export default component.exports